import './Home.scss';

import SCphoto2 from '../../assets/img/SCphoto2.jpg';
import SCphoto3 from '../../assets/img/SCphoto3.jpg';


const Home = () => {

  return (
    <>
      {/* Главный экран */}
      <section className="upper-wrapper">
        <div className="container">
          <h1 className="title title_main">Консалтинг и разработка цифрового успеха</h1>
        </div>
      </section>

      <section className="main-block">
        <div className="container">
          <div className="main-wrapper">
            <h2 className="title main-block__title title_block">
              Работы
            </h2>
            {/* <div className="tabs" style={{ visibility: 'hidden' }}>
              <div className="tab tab-1">Все проекты</div>
              <div className="tab tab-2 tab_active">Проекты клиентов</div>
              <div className="tab tab-3">Наши проекты</div>
            </div> */}
            <div className="line line_main" />
          </div>
          <div className="project">
            <div className="photo-wrapper">
              <img className="project__photo project__photo-1" src={SCphoto2} alt="project_photo#1" />
              <img className="project__photo project__photo-2" src={SCphoto3} alt="project_photo#2" />
            </div>
            <div className="project__descr">
              <h3 className="project__title">
                Smartcon - Смарт контролёр
              </h3>
              <a href="smartcon">Посмотреть</a>
              <div className="project__text">
                Создан для улучшения качества обслуживания населения. С помощью приложения вы можете подавать
                заявки для получения государственных услуг.
              </div>
              <div className="project__tags">
                <div className="project__tag project__tag-1">smartcon</div>
                <div className="project__tag project__tag-2">2021</div>
                <div className="project__tag project__tag-3">mobile</div>
                <div className="project__tag project__tag-4">web</div>
                <div className="project__tag project__tag-5">design</div>
                <div className="project__tag project__tag-6">UI/UX</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
